module.exports = __webpack_public_path__ + "img/QLIK ppt for website.c69f44a9.png";